import { useEffect, useState } from "react";

const CarbonInfo = (): React.JSX.Element | null => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const checkBadge = () => {
      const badge = document.querySelector<HTMLDivElement>("#wcb");
      if (!badge) return;
      const value = badge.getAttribute("value");
      if (value && value !== "No Result") {
        setIsVisible(true);
      }
    };

    // Attendre que le script ait créé le badge
    const timeout = setTimeout(checkBadge, 500); // tu peux ajuster le délai
    return () => clearTimeout(timeout);
  }, []);

  if (!isVisible) return null;

  return <div id="wcb" className="carbonbadge carbonInfo"></div>;
};

export default CarbonInfo;
